import React from "react";
import { Grid, Box, Paper } from "@mui/material";
import GraphComponent from "../../../GraphComponent/GraphComponent";
import QuestionsAnsweredGraphExpertOverview from "../../../GraphComponent/QuestionsAnsweredGraphExpertOverview";
import styles from "./ExpertOverview.module.css";

export default function QuestionsAndAnswersGraph() {
  return (
    <div className={styles.ExpertOutline}>
      <Grid
        container
        spacing={2}
        xs={12}
        sm={12}
        lg={12}
        xl={12}
        md={12}
        sx={{ width: "100%", padding: "0px" }}
      >
        <Grid item lg={6} xl={6} sm={12} xs={12} md={12}>
          <Paper>
            <Box>
              <QuestionsAnsweredGraphExpertOverview />
            </Box>
          </Paper>
        </Grid>
        <Grid item lg={6} xl={6} xs={12} md={12} sm={12}>
          <Paper>
            <GraphComponent type="Bar" name="Answers Viewed" />
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
}
